import { useFetchData } from "../../../hooks/useFetch";
import { ApiConfig, API_PRIVILEGE_ROUTER } from "../../../services/api-config";

// ==========================
// INTERFACES
// ==========================
export interface Privilege {
  id: number;
  name: string;
  code: string;
  description?: string;
  privilege_function_id: number;
}

export interface PrivilegeFunctionGroup {
  id: number;
  function_name: string;
  privileges: Privilege[];
}

export interface PrivilegeGroup {
  id: number;
  name: string;
  privilege_ids: number[];
  user_count: number;
  created_at: string;
}

// ==========================
// SERVICE IMPLEMENTATION
// ==========================
export const PrivilegeService = {
  // 🔹 Lấy danh sách tất cả quyền (theo nhóm chức năng)
  listPrivileges: () => {
    const { request, baseResponse, loading } = useFetchData.Get<PrivilegeFunctionGroup[]>({
      projectId: ApiConfig.PROJECT_ID.USER_SERVICE,
    });

    return {
      fetch: () =>
        request({
          endPoint: API_PRIVILEGE_ROUTER.API_PRIVILEGE_LIST,
        }),
      response: baseResponse,
      loading,
    };
  },

  // 🔹 Lấy danh sách nhóm quyền
  listGroups: () => {
    const { request, baseResponse, loading } = useFetchData.Get<PrivilegeGroup[]>({
      projectId: ApiConfig.PROJECT_ID.USER_SERVICE,
    });

    return {
      fetch: () =>
        request({
          endPoint: API_PRIVILEGE_ROUTER.API_GROUP_LIST,
        }),
      response: baseResponse,
      loading,
    };
  },

  // 🔹 Chi tiết nhóm quyền
  detailGroup: () => {
    const { request, baseResponse, loading } = useFetchData.Get<PrivilegeGroup>({
      projectId: ApiConfig.PROJECT_ID.USER_SERVICE,
    });

    return {
      fetch: (id: number) =>
        request({
          endPoint: API_PRIVILEGE_ROUTER.API_GROUP_DETAIL(id),
        }),
      response: baseResponse,
      loading,
    };
  },

  // 🔹 Tạo nhóm quyền mới
  createGroup: () => {
    const { request, baseResponse, loading } = useFetchData.Post({
      projectId: ApiConfig.PROJECT_ID.USER_SERVICE,
    });

    return {
      fetch: (payload: { name: string; privilege_ids: number[] }) =>
        request({
          endPoint: API_PRIVILEGE_ROUTER.API_GROUP_CREATE,
          data: payload,
        }),
      response: baseResponse,
      loading,
    };
  },

  // 🔹 Cập nhật nhóm quyền
  updateGroup: () => {
    const { request, baseResponse, loading } = useFetchData.Post({
      projectId: ApiConfig.PROJECT_ID.USER_SERVICE,
    });

    return {
      fetch: (id: number, payload: { name: string; privilege_ids: number[] }) =>
        request({
          endPoint: API_PRIVILEGE_ROUTER.API_GROUP_UPDATE(id),
          data: payload,
        }),
      response: baseResponse,
      loading,
    };
  },

  // 🔹 Xóa nhóm quyền
  deleteGroup: () => {
    const { request, baseResponse, loading } = useFetchData.Post({
      projectId: ApiConfig.PROJECT_ID.USER_SERVICE,
    });

    return {
      fetch: (payload: { id: number }) =>
        request({
          endPoint: API_PRIVILEGE_ROUTER.API_GROUP_DELETE,
          data: payload,
        }),
      response: baseResponse,
      loading,
    };
  },

  // 🔹 Gán nhóm quyền cho user
  assignToUser: () => {
    const { request, baseResponse, loading } = useFetchData.Post({
      projectId: ApiConfig.PROJECT_ID.USER_SERVICE,
    });

    return {
      fetch: (payload: { user_id: number; privilege_group_id: number }) =>
        request({
          endPoint: API_PRIVILEGE_ROUTER.API_GROUP_ASSIGN,
          data: payload,
        }),
      response: baseResponse,
      loading,
    };
  },
};
